export default __webpack_public_path__ + "static/media/ISOLOGO_HENRY_BLACK.1a7ecccc.png";